import { useTranslation } from "react-i18next";
import { previewModesFor, previewModesMatch } from "../../lib/metadata-builder/preview-modes";
import { useMetadataBuilderStore, type BuilderPreviewMode } from "../../stores/metadata-builder-store";
import { Button } from "../ui/button";

export function PreviewModeButtons() {
  const { t } = useTranslation();
  const previewModes = useMetadataBuilderStore(state => state.previewModes);
  const setPreviewModes = useMetadataBuilderStore(state => state.setPreviewModes);
  const labels: Record<BuilderPreviewMode, string> = {
    mixed: t("builder.preview.mixed"),
    one_slot: t("builder.step.oneSlot"),
    two_slot: t("builder.step.twoSlot"),
    offline: t("builder.preview.offline"),
  };
  const modes = Object.keys(labels) as BuilderPreviewMode[];
  // Match the panel footer action row. Active mode keeps the hover highlight.
  return <div className="flex flex-wrap items-center gap-2 border-t border-neutral-200/60 bg-neutral-50/50 pt-2">{modes.map(mode => {
    const active = previewModesMatch(previewModes, mode);
    const activeClass = active ? "text-neutral-950 before:bg-neutral-200/80" : undefined;
    return <Button key={mode} variant="action" size="sm" className={activeClass} onClick={() => setPreviewModes(previewModesFor(mode))}>{labels[mode]}</Button>;
  })}</div>;
}
